import { mapGetters, mapActions } from 'vuex';

import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';

export default {
  REQUEST_LIFECYCLE,
  computed: {
    ...mapGetters('entities', {
      messageEntities: 'messages',
    }),
    ...mapGetters('dashboard/job', [
      'currentJobMessagesMeta',
      'getRawJobMessagesByJobId',
      'getGroupedByDateCurrentRawMessagesByJobId',
    ]),
    message () {
      const message = this.messageEntities[this.messageId];

      return (
        message && {
          ...message,
          time_created: addUTCTimeZoneDesignator(message.time_created),
          time_read: message.time_read && addUTCTimeZoneDesignator(message.time_read),
        }
      );
    },
  },
  methods: {
    ...mapActions('dashboard/job', [
      'fetchMessages',
      'resetCurrentMessages',
      'createMessages',
    ]),
  },
};
